/**
 * ProPlusHomeScreenTags — iter87.210.
 *
 * BLAST-RADIUS BOUNDARY (same pattern as ClerkTokenBridge above): these
 * <head> tags are injected ONLY while a /rivalry-pro/* route is mounted
 * and removed on unmount, so Site Admin / Platform Console / regular
 * league pages never pick up the Pro+-branded manifest or icon just by
 * being on the same domain.
 *
 * Covers both platforms' "Add to Home Screen" branding:
 *   - iOS Safari reads `apple-touch-icon` + `apple-mobile-web-app-*`
 *     meta tags (no manifest.json support pre-17.4).
 *   - Android Chrome reads the linked manifest.json for name + icons.
 *
 * No service worker registered here — this is icon/name branding
 * only, deliberately scoped down from the fuller PWA plan (manifest +
 * scoped service worker + install-prompt wiring) per operator
 * direction 2026-09-05: not worth the added complexity/OAuth caveats
 * for now, just the icon + banner.
 */
import { useEffect } from "react";

const TAGS = [
    { tag: "link", attrs: { rel: "manifest", href: "/pro-plus-manifest.json" } },
    { tag: "link", attrs: { rel: "apple-touch-icon", href: "/apple-touch-icon-pro-plus.png" } },
    { tag: "meta", attrs: { name: "apple-mobile-web-app-capable", content: "yes" } },
    { tag: "meta", attrs: { name: "apple-mobile-web-app-status-bar-style", content: "black-translucent" } },
    { tag: "meta", attrs: { name: "apple-mobile-web-app-title", content: "TCR Pro+" } },
];

export default function ProPlusHomeScreenTags() {
    useEffect(() => {
        const created = TAGS.map(({ tag, attrs }) => {
            const el = document.createElement(tag);
            Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
            document.head.appendChild(el);
            return el;
        });
        return () => created.forEach((el) => el.remove());
    }, []);
    return null;
}
